import type { SVGProp } from './types';

export const vault = (props: SVGProp) => (
  <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <path
      d="M22.3659 1.25493H3.63415C2.01649 1.25493.7 2.57142.7 4.18908V22.9208c0 1.6176 1.31649 2.9341 2.93415 2.9341H22.3659c1.6176 0 2.9341-1.3165 2.9341-2.9341V4.18908c0-1.61766-1.3165-2.93415-2.9341-2.93415Zm1.7487 21.66587c0 .9639-.7849 1.7488-1.7487 1.7488H3.63415c-.9639 0-1.74878-.7849-1.74878-1.7488V4.18908c0-.9639.78488-1.74878 1.74878-1.74878H22.3659c.9638 0 1.7487.78488 1.7487 1.74878V22.9208Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.60247 7.83221c.3697-.3697.96903-.3697 1.33873 0l1.7693 1.7692c.7483-.49561 1.6456-.78424 2.6104-.78424.9647 0 1.862.28863 2.6103.78424l1.7693-1.7692c.3697-.3697.969-.3697 1.3387 0 .3697.36969.3697.96911 0 1.33881L19.27 10.9402c.4956.7483.7843 1.6457.7843 2.6104 0 .9647-.2887 1.8621-.7843 2.6103l1.7692 1.7693c.3697.3697.3697.969 0 1.3387-.3697.3698-.969.3698-1.3387 0l-1.7693-1.7691c-.7483.4955-1.6456.7842-2.6103.7842-.9648 0-1.8621-.2887-2.6104-.7842l-1.7693 1.7691c-.3697.3698-.96903.3698-1.33873 0-.3697-.3697-.3697-.969 0-1.3387l1.76923-1.7693c-.4956-.7482-.7843-1.6456-.7843-2.6103 0-.9647.2887-1.8621.7843-2.6104L9.60247 9.17102c-.3697-.3697-.3697-.96912 0-1.33881Zm2.87833 5.71839c0-1.5685 1.2716-2.8401 2.8401-2.8401 1.5684 0 2.84 1.2716 2.84 2.8401 0 1.5685-1.2716 2.84-2.84 2.84-1.5685 0-2.8401-1.2715-2.8401-2.84Z"
      fill="currentColor"
    />
    <path
      d="M6.82818 7.30142c0-.52283-.42385-.94668-.94668-.94668-.52284 0-.94669.42385-.94669.94668V19.9239c0 .5228.42385.9467.94669.9467.52283 0 .94668-.4239.94668-.9467V7.30142Z"
      fill="currentColor"
    />
  </svg>
);
